import React from 'react';
import {BasePlayersDashboard} from 'desktop/sports/nascar/players-dashboard/classic';
import DominatorStack from 'components/organisms/dominator-stacking/index';

class PlayersDashboard extends BasePlayersDashboard {
    render() {
        const Dashboard = super.render();

        return (
            <div>
                {Dashboard}
                <DominatorStack />
            </div>
        );
    }
}

export {PlayersDashboard};
